import { pstyle } from "../lib/pstyle.js";
import Hoverable from "../lib/Hoverable.jsx";

export default function IndexPage({ v }) {
  return (
    <div style={pstyle("padding:52px 44px 80px; max-width:1080px; margin:0 auto; display:flex; flex-direction:column; gap:28px;")}>
      <div style={pstyle("display:flex; flex-direction:column; gap:10px;")}>
        <h1 style={pstyle("margin:0; font-size:32px; font-weight:600; letter-spacing:-0.025em;")}>Index A→Z</h1>
        <p style={pstyle("margin:0; font-size:15px; color:oklch(0.5 0.015 60);")}>{v.indexCount} fiches classées par titre. Filtrer par domaine :</p>
      </div>
      <div style={pstyle("display:flex; gap:8px; flex-wrap:wrap;")}>
        {v.indexFilters.map((f, i) => (
          <button key={i} type="button" onClick={f.onClick} style={pstyle("font:inherit; font-size:12.5px; border-radius:999px; padding:6px 14px; cursor:pointer;", { border: "1px solid " + f.border, color: f.color })}>{f.label}</button>
        ))}
      </div>
      <div style={pstyle("display:flex; flex-direction:column;")}>
        {v.indexRows.map((r, i) => (
          <Hoverable
            key={i}
            onClick={r.onClick}
            style={pstyle("display:flex; align-items:baseline; gap:18px; padding:13px 4px; border-bottom:1px solid oklch(0.95 0.006 85); cursor:pointer;")}
            hoverStyle={{ background: "oklch(0.985 0.004 85)" }}
          >
            <span style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:12px; color:oklch(0.65 0.015 60); width:18px;")}>{r.letter}</span>
            <span style={pstyle("font-size:15px; width:300px;")}>{r.title}</span>
            <span style={pstyle("font-size:13px; color:oklch(0.5 0.015 60); flex:1; text-wrap:pretty;")}>{r.summary}</span>
            <span style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:11px; color:oklch(0.55 0.015 60); border:1px solid oklch(0.93 0.008 85); border-radius:999px; padding:3px 10px;")}>{r.domain}</span>
          </Hoverable>
        ))}
      </div>
    </div>
  );
}
